export default __webpack_public_path__ + "static/media/preorder_en.a6068a0d.svg";